export default class FilterOperatorModel {
    label = '';
    types = [];
    searchTags = '';
    valuesNeeded = 1;

    constructor(label, sublabel = '', searchTags = [], sqlFn = () => '', valuesNeeded = 1) {
        searchTags = searchTags.concat([label]).join(',');
        Object.assign(this, {label, sublabel, searchTags, sqlFn, valuesNeeded});
    }

    isMatch(searchQuery) {
        return this.searchTags.match(new RegExp(`.*${searchQuery.replace(/[-+[\](){}.*]/, '.*')}.*`, 'i'));
    }

    isValid(column, values) {
        return column && values.length >= this.valuesNeeded;
    }

    getSql(column, values) {
        return this.sqlFn(column, values);
    }
}
